var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSunLine = function SvgSunLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sun-line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.333a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334Zm-.667-10h1.334v2H7.333v-2Zm0 12.666h1.334v2H7.333v-2ZM2.343 3.286l.943-.943L4.7 3.757l-.943.943-1.414-1.413Zm8.957 8.957.943-.943 1.414 1.414-.943.943-1.414-1.414Zm1.414-9.9.943.943L12.243 4.7l-.943-.943 1.414-1.414ZM3.757 11.3l.943.943-1.414 1.414-.943-.943L3.757 11.3Zm11.576-3.967v1.334h-2V7.333h2Zm-12.666 0v1.334h-2V7.333h2Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun-line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSunLine;